import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import {
  CONFLICT_GROUP_CLASSES,
  conflictFieldGroup,
  conflictFieldLabel,
} from '../constants/conflictFieldConstants';
import type { ConflictFieldId } from '../models/conflictTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictFieldPill',
  props: {
    field: {}
  },
  setup(__props: any) {

const props = __props;

const label = computed(() => conflictFieldLabel(props.field));
const group = computed(() => conflictFieldGroup(props.field));
const groupClasses = computed(() => CONFLICT_GROUP_CLASSES[group.value]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex items-center whitespace-nowrap rounded-sm border px-2 py-0.5 text-xs font-medium uppercase tracking-wide", groupClasses.value]),
    "data-cy": "conflict-matched-field"
  }, _toDisplayString(label.value), 3))
}
}

})